module.exports = __webpack_public_path__ + "img/secret_step_1.3f1ced5d.svg";